import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, XCircle, Search, Footprints, Send, Archive, FileCheck2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";

const ACTIONS = [
  { s: "goedgekeurd", label: "Goedkeuren", icon: CheckCircle2, cls: "bg-emerald-600 hover:bg-emerald-500", hint: "Bouwwerk akkoord, volgende keer overslaan" },
  { s: "vergund", label: "Vergund", icon: FileCheck2, cls: "bg-lime-700 hover:bg-lime-600" },
  { s: "afgewezen", label: "Afwijzen (vals alarm)", icon: XCircle, cls: "bg-slate-700 hover:bg-slate-600" },
  { s: "inspecteren", label: "Inspecteren", icon: Search, cls: "bg-sky-700 hover:bg-sky-600" },
  { s: "bezoeken", label: "Bezoeken", icon: Footprints, cls: "bg-orange-600 hover:bg-orange-500" },
  { s: "doorgezet", label: "Doorzetten naar handhaving", icon: Send, cls: "bg-rose-600 hover:bg-rose-500" },
  { s: "afgehandeld", label: "Afgehandeld", icon: Archive, cls: "bg-teal-700 hover:bg-teal-600" },
];

export const StatusActions = ({ melding, onUpdated }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(null);

  const act = async (s) => {
    setBusy(s);
    try {
      const { data } = await api.patch(`/meldingen/${melding.id}`, { status: s, notitie: note });
      toast.success(`Status gewijzigd naar "${s}"`);
      setNote("");
      onUpdated?.(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="space-y-3" data-testid="status-actions">
      <Textarea data-testid="melding-note-input" placeholder="Notitie bij beoordeling (optioneel)…" value={note} onChange={(e) => setNote(e.target.value)} className="bg-slate-950 border-slate-800 text-sm min-h-[70px]" />
      <div className="grid grid-cols-2 gap-2">
        {ACTIONS.map(({ s, label, icon: Icon, cls }) => (
          <button key={s} data-testid={`btn-status-${s}`} disabled={!!busy || melding.status === s} onClick={() => act(s)}
            className={`flex items-center justify-center gap-1.5 text-xs font-medium px-2 py-2.5 rounded-md text-white transition-colors disabled:opacity-40 ${cls} ${s === "goedgekeurd" ? "col-span-2 py-3 text-sm" : ""}`}>
            <Icon className="h-4 w-4" />{busy === s ? "Bezig…" : label}
          </button>
        ))}
      </div>
      <p className="text-[11px] text-slate-500">Goedkeuren, vergund of afhandelen voegt de gedetecteerde objecten toe aan de uitzonderingen van dit perceel; bij volgende analyses worden ze overgeslagen.</p>
    </div>
  );
};
